export type ToastType = 'success' | 'error' | 'info';

export class ShowToast {
  static readonly type = '[Common] Show Toast';
  constructor(public type: ToastType = 'success', public title: string, public message?: string) { }
}
